<template>
  <v-flex
    xs6
    sm6
    class="pa-2"
  >
    <v-card
      class="align-stretch"
    >
      <v-card-title
        primary-title
        class="pa-3"
      >
        <div>
          <h3
            class="title mb-0"
          >
            {{ title }}
          </h3>
          <div
            class="caption"
          >
            {{ description }}
          </div>
          <div
            v-if="showCancelWarning"
            style="color: red;"
          >
            Do not cancel a settlement which is older than 14 days.<br>
            Never cancel a settlement of a fully funded FP!<br>
            Do you really want to cancel it?<br>
          </div>
        </div>
      </v-card-title>
      <v-card-actions
        class="justify-end"
      >
        <v-btn
          color="error"
          flat
          @click="clicked"
        >
          {{ linkTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>

export default {
  name: 'SettlementActionCard',
  props: {
    title: {
      type: String,
      default: null,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    linkTitle: {
      type: String,
      default: 'OK',
    },
    showCancelWarning: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    clicked() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/settlements/dialog/SettlementActionCard.vue